import { useEffect, useState } from "react";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";

const STORAGE_KEY = "pp_cookie_ack";

export function CookieBanner() {
  const { t } = useTranslation();
  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!localStorage.getItem(STORAGE_KEY)) setShown(true);
  }, []);

  if (!shown) return null;

  function dismiss() {
    try {
      localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    } catch {
      // ignore (private mode)
    }
    setShown(false);
  }

  return (
    <div className="cookie-banner" role="region" aria-label="Cookies">
      <p className="cookie-banner__msg">{t("cookieBanner.message")}</p>
      <div className="cookie-banner__actions">
        <Link to="/privacidade" className="cookie-banner__link">{t("cookieBanner.more")}</Link>
        <button type="button" className="btn btn-primary btn-sm" onClick={dismiss}>
          {t("cookieBanner.ok")}
        </button>
      </div>
    </div>
  );
}
